
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({})
export default class Name extends Vue {
  @Prop()
  private time: any;
  private get patient() {
    return this.$store.state.patient;
  }
}
